import React from "react";
import Carousel from "react-material-ui-carousel";
import { Box, Paper, Typography } from "@mui/material";

/**
 * @param {Array<{src:string, alt:string, caption?:string}>} images
 * @param {number|string|object} height  // optional; e.g. 420, "420px", { xs: 240, md: 420 }
 * @param {string|object} aspectRatio    // optional; e.g. "16 / 9" or { xs:"16 / 9", md:"21 / 9" }
 * @param {"cover"|"contain"} imageFit
 */
export default function GalleryCarousel({
                                            images = [],
                                            height,                 // <- if provided, overrides CSS
                                            aspectRatio,            // <- optional override; used only if height not set
                                            imageFit = "cover",
                                            autoPlay = true,
                                            indicators = true,
                                            navButtonsAlwaysVisible = true,
                                            animation = "slide",
                                            ...props
                                        }) {
    const frameSx =
        height
            ? { height } // numeric (px), string, or responsive object works with MUI
            : aspectRatio
                ? { aspectRatio }
                : undefined; // fall back to CSS (.baex-carousel__frame)

    return (
        <Box className="baex-carousel">
            <Carousel
                autoPlay={autoPlay}
                indicators={indicators}
                navButtonsAlwaysVisible={navButtonsAlwaysVisible}
                animation={animation}
                {...props}
            >
                {images.map((img) => (
                    <Paper key={img.src} elevation={0} sx={{ m: 0, p: 0, bgcolor: "transparent" }}>
                        <Box className="baex-carousel__frame" sx={frameSx}>
                            <Box
                                component="img"
                                src={img.src}
                                alt={img.alt}
                                loading="lazy"
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: imageFit,
                                    display: "block",
                                }}
                            />
                        </Box>
                        {img.caption && (
                            <Typography variant="caption" sx={{ display: "block", textAlign: "center", mt: 1 }}>
                                {img.caption}
                            </Typography>
                        )}
                    </Paper>
                ))}
            </Carousel>
        </Box>
    );
}
